import React from "react";
import { useCart } from "../Cart/CartContext";
import { Link } from "react-router-dom";
import { FaRegTrashCan } from "react-icons/fa6";

const CartContent = () => {
  const { cart, removeFromCart, addToCart } = useCart();

  const calculateTotal = () => {
    return cart.reduce((total, item) => {
      return total + item.quantity * item.price;
    }, 0);
  };

  const increaseQuantity = (item) => {
    addToCart({
      id: item.id,
      size: item.size,
      color: item.color,
      variantId: item.variantId,
      quantity: 1,
    });
  };

  const decreaseQuantity = (item) => {
    if (item.quantity > 1) {
      addToCart({
        id: item.id,
        size: item.size,
        color: item.color,
        variantId: item.variantId,
        quantity: -1,
      });
    }
  };

  return (
    <div className="p-6 pb-[250px] md:pb-[120px] mx-auto bg-white">
      <h2 className="text-[50px] font-semibold poppins text-gray-800 border-b pb-3">
        Your Cart
      </h2>

      <div className="text-lg poppins font-semibold text-gray-800 mt-4">
        <p>{cart.length} {cart.length === 1 ? "Item" : "Items"} in your cart</p>
      </div>

      {cart.length === 0 ? (
        <p className="text-gray-500 mt-6 text-center">Your cart is empty.</p>
      ) : (
        <div className="space-y-4 mt-4">
          {cart.map((item) => (
            <div key={`${item.id}-${item.size}-${item.color}-${item.variantId}`} className="flex items-center justify-between p-3 bg-gray-100 rounded-md shadow-sm">

              {/* IMAGE */}
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.model}
                  className="w-16 h-16 object-cover rounded-md"
                />

                <span className="absolute top-0 right-0 bg-black text-white text-xs font-semibold py-1 px-2 rounded-full">
                  {item.quantity}
                </span>
              </div>

              {/* PRODUCT INFO */}
              <div className="flex-1 ml-4">
                <p className="font-medium text-[12px] text-gray-800">{item.name}</p>
                <p className="text-[10px] text-gray-600">Size: {item.size}</p>
                <p className="text-[10px] text-gray-600">Color: {item.color}</p>

                {/* QUANTITY */}
                <div className="flex items-center mt-2">
                  <button className="px-2" onClick={() => decreaseQuantity(item)}>-</button>
                  <span className="text-[12px] px-2">{item.quantity}</span>
                  <button className="px-2" onClick={() => increaseQuantity(item)}>+</button>
                </div>

                {/* PRICE */}
                <div className="flex justify-between mt-2">
                  <span className="text-sm text-gray-600">{item.price} DT</span>
                  <span className="text-sm text-gray-600">
                    Total:  {(item.quantity * item.price).toLocaleString()} DT
                  </span>
                </div>
              </div>

              {/* REMOVE */}
              <button onClick={() => removeFromCart(item)} className="text-black">
                <FaRegTrashCan className="md:h-5 md:w-5 w-3 h-3" />
              </button>
            </div>
          ))}

          {/* CART TOTAL */}
          <div className="border-t pt-4">
            <div className="flex justify-between items-center text-lg font-semibold mb-8">
              <span>Total:</span>
              <span>{calculateTotal().toLocaleString()} DT</span>
            </div>

            <div className="flex justify-center">
              <Link
                to="/checkout"
                className="block text-center text-[15px] bg-black text-white font-medium py-2 px-6 poppins hover:bg-gray-800 transition"
              >
                Checkout
              </Link>
            </div>

            <p className="text-sm text-gray-500 mt-2 text-center">
              Shipping, taxes, and discount codes calculated at checkout
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartContent;
